import { FunctionComponent } from 'react';
import AdsAdvantageWrapper from './adsAdvantage.style';

const AdsAdvantage: FunctionComponent = () => {
  const adsAdvantages = [
    {
      title: '원하는 타기팅으로 높은 만족도',
      description: '변호사님의 주력 분야와 활동하시는 지역에만 선택적으로 광고할 수 있습니다.',
    },
    {
      title: '광고가 끝나도 오래 지속되는 효과',
      description:
        '광고를 통해 이루어진 상담활동이 콘텐츠로 쌓이고, 로톡 뿐 아니라 외부 검색포탈에도 노출이 되어 지속적인 광고 효과를 낼 수 있습니다.',
    },
    {
      title: '비즈니스 매니저의 1:1 밀착관리',
      description:
        '로톡 서비스 이용과 활동, 광고성과를 극대화할 수 있도록 로톡 비즈니스 매니저가 1:1 밀착 관리를 해 드립니다.',
    },
    {
      title: '멋지고, 매력있고 퀄리티 높은 광고',
      description:
        '로톡은 광고를 만들 때 변호사님이 전문성이 잘 느껴질 수 있도록, 의뢰인이 변호사님께 좋은 느낌을 갖고 연락하도록 고민하고 디자인합니다.',
    },
  ];
  return (
    <AdsAdvantageWrapper>
      <div className="adsadvantage--header">
        <p className="adscomp--subtitle">Advantage</p>
        <p className="adscomp--title">어떤 점이 좋은가요?</p>
      </div>
      <div className="adsadvantage--body">
        <div className="adsadvantage--list">
          {adsAdvantages.map((advantage, index) => (
            <div className="adsadvantage--item" key={index}>
              <p className="adsadvantage--item-title">{advantage.title}</p>
              <p className="adsadvantage--item-desc">{advantage.description}</p>
            </div>
          ))}
        </div>
      </div>
    </AdsAdvantageWrapper>
  );
};

export default AdsAdvantage;
